import { z } from "zod";

export const escAcquisitionEligibilityResponseDto = z.object({
  isEstimateMandatory: z.boolean(),
});

export type TEscAcquisitionEligibilityResponse = z.infer<typeof escAcquisitionEligibilityResponseDto>;
